

export const absenceTypes = [
  { label: 'Vacaciones', value: 'VACATION' },
  { label: 'Incapacidad Médica', value: 'SICK_LEAVE' },
  { label: 'Permiso Remunerado', value: 'PAID_LEAVE' },
  { label: 'Permiso No Remunerado', value: 'UNPAID_LEAVE' },
  { label: 'Calamidad Doméstica', value: 'BEREAVEMENT' },
  { label: 'Licencia de Maternidad', value: 'MATERNITY_LEAVE' },
  { label: 'Licencia de Paternidad', value: 'PATERNITY_LEAVE' },

  // Recomendados
  { label: 'Licencia por Luto', value: 'BEREAVEMENT_LEAVE' },
  { label: 'Cita Médica', value: 'MEDICAL_APPOINTMENT' },
  { label: 'Accidente Laboral', value: 'WORK_ACCIDENT' },
  { label: 'Enfermedad Laboral', value: 'OCCUPATIONAL_DISEASE' },
  { label: 'Licencia Sindical', value: 'UNION_LEAVE' },
  { label: 'Licencia por Estudio', value: 'STUDY_LEAVE' },
  { label: 'Licencia por Jurado de Votación', value: 'JURY_DUTY' },
  { label: 'Licencia por Servicio Militar', value: 'MILITARY_SERVICE' },
  { label: 'Suspensión Disciplinaria', value: 'DISCIPLINARY_SUSPENSION' },
  { label: 'Ausencia Injustificada', value: 'UNEXCUSED_ABSENCE' },
  { label: 'Huelga', value: 'STRIKE' },
  { label: 'Teletrabajo', value: 'REMOTE_WORK' } // si deseas registrar que no asistió físicamente
];

export const approvalStatuses = [
  { label: 'Pendiente', value: 'PENDING' },
  { label: 'Aprobada', value: 'APPROVED' },
  { label: 'Rechazada', value: 'REJECTED' }
];